/**
 * Label utility for schedule renderer views
 * Finds an item's first label (or its color) for tinting schedule item cards and blocks.
 */

import type { ScheduleItemRow, ScheduleLabelRow } from "../../../../_logic/types/db-types";

/**
 * Returns the color of the first assigned label for a schedule item, or null if none
 * @param item - The schedule item
 * @param labelMap - Map of label ID to label row
 * @returns The hex color string or null
 */
export function getFirstLabelColor(item: ScheduleItemRow, labelMap: Map<number, ScheduleLabelRow>): string | null {
  for (const id of item.label_ids) {
    const label = labelMap.get(id);
    if (label?.color) return label.color;
  }
  return null;
}

/**
 * Returns the first assigned label (in the item's label order) that exists in the map.
 * @param item - The schedule item
 * @param labelMap - Map of label ID to label row
 * @returns The label row, or null when the item has no known labels
 */
export function getFirstLabel(item: ScheduleItemRow, labelMap: Map<number, ScheduleLabelRow>): ScheduleLabelRow | null {
  for (const id of item.label_ids) {
    const label = labelMap.get(id);
    if (label) return label;
  }
  return null;
}
